import { string, oneOf, func, number, bool } from 'prop-types'
import { useState } from 'react'
import {
  FluidInput,
  Tooltip,
  PopoverV2,
  kuiperClassNames,
  renderIcon,
} from '@opallabs/kuiper'
import CtaPopoverContent from './CtaPopoverContent'
import './styles.scss'

const linkIcon = (contentProps) => {
  const icon =
    contentProps.originalUrl || contentProps.readOnly ? 'url' : 'url-add'
  const tooltipVerb =
    contentProps.value || contentProps.readOnly ? 'View' : 'Add'
  const iconWithPopover = (
    <PopoverV2
      className="cta-icon-popover"
      trigger={renderIcon(icon, {
        ariaLabel: `${tooltipVerb} CTA URL`,
        ariaMode: 'presentational',
      })}
      content={<CtaPopoverContent {...contentProps} />}
    />
  )

  return (
    <Tooltip
      className="cta-icon-tooltip"
      trigger={iconWithPopover}
      content={`${tooltipVerb} CTA URL`}
    />
  )
}

const CallToAction = ({
  ctaValue = '',
  forceUpdate,
  maxWidth,
  placeholder = 'Add CTA...',
  readOnly = false,
  theme = 'dark',
  type = 'primary',
  updateCta,
  updateUrl,
  urlValue = '',
}) => {
  const [text, setText] = useState(ctaValue)
  const [url, setUrl] = useState(urlValue)
  const onCopyLink = () => window.navigator.clipboard.writeText(urlValue)

  return (
    <div className={kuiperClassNames('cta-section', theme, type, { readOnly })}>
      <FluidInput
        className="cta-input"
        disabled={readOnly}
        forceUpdate={forceUpdate}
        maxWidth={maxWidth}
        minRows={1}
        maxRows={3}
        onBlur={() => updateCta(text)}
        onChange={(value) => setText(value)}
        placeholder={placeholder}
        theme={theme}
        value={text}
      />
      {Boolean(!readOnly || url.length) &&
        linkIcon({
          value: url,
          onUrlChange: setUrl,
          updateUrl,
          originalUrl: urlValue,
          onCopyLink,
          readOnly,
        })}
    </div>
  )
}

CallToAction.propTypes = {
  ctaValue: string,
  forceUpdate: bool,
  maxWidth: number,
  placeholder: string,
  readOnly: bool,
  theme: oneOf(['dark', 'light']),
  type: oneOf(['primary', 'secondary']),
  updateCta: func.isRequired,
  updateUrl: func.isRequired,
  urlValue: string,
}

export default CallToAction
